import { render, staticRenderFns } from "./AddDocumentPurchaseReorder.vue?vue&type=template&id=5e9d38df&"
import script from "./AddDocumentPurchaseReorder.vue?vue&type=script&lang=js&"
export * from "./AddDocumentPurchaseReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports